import React from 'react';
import { PayPalScriptProvider } from '@paypal/react-paypal-js';

interface PayPalProviderProps {
  children: React.ReactNode;
}

export const PayPalProvider: React.FC<PayPalProviderProps> = ({ children }) => {
  const clientId = process.env.REACT_APP_PAYPAL_CLIENT_ID || '';
  
  if (!clientId) {
    console.error('PayPal Client ID is not configured');
    return <>{children}</>;
  }
  
  console.log('PayPal Configuration:');
  console.log('Client ID:', clientId.substring(0, 10) + '...');
  
  const paypalOptions = {
    clientId: clientId,
    currency: 'USD',
    intent: 'capture',
    enableFunding: 'venmo,paylater',
    disableFunding: 'card',
    components: 'buttons',
    debug: process.env.NODE_ENV === 'development'
  };

  return (
    <PayPalScriptProvider 
      options={paypalOptions}
      deferLoading={false}
    >
      {children}
    </PayPalScriptProvider>
  );
};